import React from 'react';
import { useRecoilState } from 'recoil';
import _ from 'lodash';
import {
  Modal
} from 'antd';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/pro-duotone-svg-icons';
import { newSubmissionAtom } from '../../../atoms/Atoms';
import { H1, H2, H3 } from '../typography/Title';

function NewSubmissionSuccessModal() {
  const { t } = useTranslation();
  const [newSubmission, setNewSubmission] = useRecoilState(newSubmissionAtom);

  return (
    <Modal
      onCancel={() => setNewSubmission(null)}
      open={newSubmission}
      footer={[]}
    >
        <div className="text-center flex flex-col space-y-2">
          <FontAwesomeIcon className="mx-auto text-7xl text-green-600" icon={faCheckCircle} />
          <H1 text={t('new_submission_success.thank_you')} />
          <H3 text={t('new_submission_success.text_upper')} />
          <H2 text={newSubmission?.externalDealId} className="text-primaryColor" />
          <H3 text={t('new_submission_success.text_lower')} />
        </div>
    </Modal>
  );
}

export default NewSubmissionSuccessModal;
